import { Table, Input } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { useState } from "react";
import PropTypes from "prop-types";

const { Search } = Input;

const DownloadAndSync = ({ approvedList, loadFile }) => {
  const [searchText, setSearchText] = useState("");

  const handleSearch = (value) => {
    setSearchText(value.toLowerCase());
  };

  const filteredData = approvedList.filter((item) =>
    item?.file_name?.toLowerCase().includes(searchText)
  );

  const columns = [
    {
      title: "File Name",
      dataIndex: "file_name",
      key: "file_name",
      sorter: (a, b) => a.file_name.localeCompare(b.file_name),
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Output",
      dataIndex: ["result", "output"],
      key: "output",
      render: (output) => JSON.stringify(output),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <FilePdfOutlined
          onClick={() => loadFile(record?.position)}
          style={{ cursor: "pointer" }}
        />
      ),
    },
  ];

  return (
    <div>
      <Search
        placeholder="Search by file name"
        onSearch={handleSearch}
        onChange={(e) => handleSearch(e.target.value)}
        style={{ marginBottom: 16, width: 300 }}
      />
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey={(record) => record.file_name}
        pagination={{ pageSize: 6 }}
      />
    </div>
  );
};

DownloadAndSync.propTypes = {
  approvedList: PropTypes.object,
  loadFile: PropTypes.func,
};

export { DownloadAndSync };
